export default __webpack_public_path__ + "static/media/newpayLogoDark.77d47eff.png";